// Icons: https://fonts.google.com/icons
export const errorIcon = "error";
export const isValidIcon = "check_circle";
